module.exports = {
  success: false,
  error: "error",
  loading: "loading",
};
